import hero01Pc from "../img/decoration/mv-parts-01-pc.png";
import hero01Sp from "../img/decoration/mv-parts-01-sp.png";
import hero02Pc from "../img/decoration/mv-parts-02-pc.png";
import hero02Sp from "../img/decoration/mv-parts-02-sp.png";
import hero03Pc from "../img/decoration/mv-parts-03-pc.png";
import hero03Sp from "../img/decoration/mv-parts-03-sp.png";

import service01 from "../img/decoration/top-service-dec1.svg";
import service02 from "../img/decoration/top-service-dec2.svg";
import service03 from "../img/decoration/top-service-dec3.svg";

import visionMission01Pc from "../img/decoration/top-vision-mission-dec1.svg";
import visionMission02Pc from "../img/decoration/top-vision-mission-dec2.svg";
import visionMission01Sp from "../img/decoration/top-vision-mission-sp-dec1.svg";
import visionMission02Sp from "../img/decoration/top-vision-mission-sp-dec2.svg";

import news01 from "../img/decoration/top-news-dec1.svg";

import contact01 from "../img/decoration/top-contact-dec1.svg";
import contact02 from "../img/decoration/top-contact-dec2.svg";

export const IMAGE_MAP = {
  "page-hero": {
    pc: [
      { src: hero01Pc, className: "decor-hero-01" },
      { src: hero02Pc, className: "decor-hero-02" },
      { src: hero03Pc, className: "decor-hero-03" },
    ],
    sp: [
      { src: hero01Sp, className: "decor-hero-01" },
      { src: hero02Sp, className: "decor-hero-02" },
      { src: hero03Sp, className: "decor-hero-03" },
    ],
  },

  "section-service": {
    pc: [
      { src: service01, className: "decor-service-01", target: ".wp-block-media-text__media" },
      { src: service02, className: "decor-service-02", target: ".wp-block-media-text__media" },
      { src: service03, className: "decor-service-03", target: ".service-title" },
    ],
    sp: [
      { src: service01, className: "decor-service-01", target: ".wp-block-media-text__media" },
      { src: service02, className: "decor-service-02", target: ".wp-block-media-text__media" },
      { src: service03, className: "decor-service-03", target: ".service-title" },
    ],
  },

  "section-vision-mission": {
    pc: [
      { src: visionMission01Pc, className: "decor-vision-mission-01", target: ".title-content" },
      { src: visionMission02Pc, className: "decor-vision-mission-02" },
    ],
    sp: [
      { src: visionMission01Sp, className: "decor-vision-mission-01", target: ".title-content" },
      { src: visionMission02Sp, className: "decor-vision-mission-02" },
    ],
  },

  "section-news": {
    pc: [{ src: news01, className: "decor-news-01" }],
    sp: [{ src: news01, className: "decor-news-01" }],
  },

  "section-contact": {
    pc: [
      { src: contact01, className: "decor-contact-01" },
      { src: contact02, className: "decor-contact-02" },
    ],
    sp: [
      { src: contact01, className: "decor-contact-01" },
      { src: contact02, className: "decor-contact-02" },
    ],
  },
};